import { openBlock, createElementBlock, normalizeClass, createElementVNode, normalizeStyle, Fragment, renderList, toDisplayString, createCommentVNode, pushScopeId, popScopeId } from 'vue';

var script = {
  name: "Pagination",
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    pageCount: {
      type: Number,
      default: 5
    },
    totalPage: {
      type: Number,
      default: 1
    },
    paginationItemClass: {
      type: String
    },
    paginationLinkClass: {
      type: String
    },
    paginationContainerClass: {
      type: String
    },
    paginationItemActiveClass: {
      type: String
    },
    height: {
      type: [String, Number],
      default: "35px"
    },
    width: {
      type: [String, Number],
      default: "35px"
    },
    firstTitle: {
      type: String,
      default: "First"
    },
    previousTitle: {
      type: String,
      default: "Previous"
    },
    nextTitle: {
      type: String,
      default: "Next"
    },
    lastTitle: {
      type: String,
      default: "Last"
    }
  },
  emits: ["pageChange"],
  methods: {
    handlePageChange(page) {
      this.$emit("pageChange", page);
    }

  },
  computed: {
    start() {
      return this.currentPage > this.totalPage - Math.floor((this.pageCount - 1) / 2) ? this.totalPage - (this.pageCount - 1) : this.currentPage - Math.floor((this.pageCount - 1) / 2);
    },

    end() {
      return this.currentPage <= Math.floor(this.pageCount / 2) ? this.pageCount : this.currentPage + Math.floor(this.pageCount / 2);
    },

    range() {
      const pages = [];

      for (let i = this.start; i <= this.end; i++) {
        if (i > 0 && i <= this.totalPage) {
          pages.push(i);
        }
      }

      return pages;
    },

    sizeStyle() {
      return {
        height: this.height,
        width: this.width
      };
    },

    iconSizeStyle() {
      const height = parseInt(this.height.replace("px", "") - 10);
      const width = parseInt(this.width.replace("px", "") - 10);
      return {
        height,
        width
      };
    }

  }
};

const _withScopeId = n => (pushScopeId("data-v-f6c6472e"), n = n(), popScopeId(), n);

const _hoisted_1 = ["title"];

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/createElementVNode("path", {
  d: "M31.1 64.03c-17.67 0-31.1 14.33-31.1 32v319.9c0 17.67 14.33 32 32 32C49.67 447.1 64 433.6 64 415.1V96.03C64 78.36 49.67 64.03 31.1 64.03zM267.5 71.41l-192 159.1C67.82 237.8 64 246.9 64 256c0 9.094 3.82 18.18 11.44 24.62l192 159.1c20.63 17.12 52.51 2.75 52.51-24.62v-319.9C319.1 68.66 288.1 54.28 267.5 71.41z"
}, null, -1));

const _hoisted_3 = [_hoisted_2];
const _hoisted_4 = ["title"];

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/createElementVNode("path", {
  d: "M77.25 256l137.4-137.4c12.5-12.5 12.5-32.75 0-45.25s-32.75-12.5-45.25 0l-160 160c-12.5 12.5-12.5 32.75 0 45.25l160 160C175.6 444.9 183.8 448 192 448s16.38-3.125 22.62-9.375c12.5-12.5 12.5-32.75 0-45.25L77.25 256zM269.3 256l137.4-137.4c12.5-12.5 12.5-32.75 0-45.25s-32.75-12.5-45.25 0l-160 160c-12.5 12.5-12.5 32.75 0 45.25l160 160C367.6 444.9 375.8 448 384 448s16.38-3.125 22.62-9.375c12.5-12.5 12.5-32.75 0-45.25L269.3 256z"
}, null, -1));

const _hoisted_6 = [_hoisted_5];
const _hoisted_7 = ["onClick"];
const _hoisted_8 = ["title"];

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/createElementVNode("path", {
  d: "M246.6 233.4l-160-160c-12.5-12.5-32.75-12.5-45.25 0s-12.5 32.75 0 45.25L178.8 256l-137.4 137.4c-12.5 12.5-12.5 32.75 0 45.25C47.63 444.9 55.81 448 64 448s16.38-3.125 22.62-9.375l160-160C259.1 266.1 259.1 245.9 246.6 233.4zM438.6 233.4l-160-160c-12.5-12.5-32.75-12.5-45.25 0s-12.5 32.75 0 45.25L370.8 256l-137.4 137.4c-12.5 12.5-12.5 32.75 0 45.25C239.6 444.9 247.8 448 256 448s16.38-3.125 22.62-9.375l160-160C451.1 266.1 451.1 245.9 438.6 233.4z"
}, null, -1));

const _hoisted_10 = [_hoisted_9];
const _hoisted_11 = ["title"];

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/createElementVNode("path", {
  d: "M287.1 447.1c17.67 0 31.1-14.33 31.1-32V96.03c0-17.67-14.33-32-32-32c-17.67 0-31.1 14.33-31.1 31.1v319.9C255.1 433.6 270.3 447.1 287.1 447.1zM52.51 440.6l192-159.1c7.625-6.436 11.43-15.53 11.43-24.62c0-9.094-3.809-18.18-11.43-24.62l-192-159.1C31.88 54.28 0 68.66 0 96.03v319.9C0 443.3 31.88 457.7 52.51 440.6z"
}, null, -1));

const _hoisted_13 = [_hoisted_12];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return $props.totalPage ? (openBlock(), createElementBlock("ul", {
    key: 0,
    class: normalizeClass({
      'vue3-paginate-pagination-container': [undefined, null, ''].includes($props.paginationContainerClass),
      [$props.paginationContainerClass]: $props.paginationContainerClass
    })
  }, [createElementVNode("li", {
    style: normalizeStyle($options.sizeStyle),
    class: normalizeClass({
      'vue3-paginate-not-allowed': 1 >= $props.currentPage,
      'vue3-paginate-pagination-item': [undefined, null, ''].includes($props.paginationItemClass),
      [$props.paginationItemClass]: $props.paginationItemClass
    }),
    onClick: _cache[0] || (_cache[0] = $event => 1 >= $props.currentPage ? null : $options.handlePageChange(1))
  }, [createElementVNode("a", {
    title: $props.firstTitle,
    class: normalizeClass({
      [$props.paginationLinkClass]: $props.paginationLinkClass,
      'vue3-paginate-not-allowed': 1 >= $props.currentPage
    })
  }, [(openBlock(), createElementBlock("svg", {
    style: normalizeStyle($options.iconSizeStyle),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512"
  }, _hoisted_3, 4))], 10, _hoisted_1)], 6), createElementVNode("li", {
    style: normalizeStyle($options.sizeStyle),
    class: normalizeClass({
      'vue3-paginate-not-allowed': 1 >= $props.currentPage,
      'vue3-paginate-pagination-item': [undefined, null, ''].includes($props.paginationItemClass),
      [$props.paginationItemClass]: $props.paginationItemClass
    }),
    onClick: _cache[1] || (_cache[1] = $event => 1 >= $props.currentPage ? null : $options.handlePageChange($props.currentPage - 1))
  }, [createElementVNode("a", {
    title: $props.previousTitle,
    class: normalizeClass({
      'vue3-paginate-not-allowed': 1 >= $props.currentPage,
      [$props.paginationLinkClass]: $props.paginationLinkClass
    })
  }, [(openBlock(), createElementBlock("svg", {
    style: normalizeStyle($options.iconSizeStyle),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512"
  }, _hoisted_6, 4))], 10, _hoisted_4)], 6), (openBlock(true), createElementBlock(Fragment, null, renderList($options.range, i => {
    return openBlock(), createElementBlock("li", {
      style: normalizeStyle($options.sizeStyle),
      onClick: $event => i === $props.currentPage ? null : $options.handlePageChange(i),
      class: normalizeClass({
        'vue3-paginate-pagination-item': [undefined, null, ''].includes($props.paginationItemClass),
        'vue3-paginate-not-allowed': i === $props.currentPage,
        'vue3-paginate-active': [undefined, null, ''].includes($props.paginationItemClass) && i === $props.currentPage,
        [$props.paginationItemActiveClass]: $props.paginationItemActiveClass && i === $props.currentPage,
        [$props.paginationItemClass]: $props.paginationItemClass
      }),
      key: i
    }, [createElementVNode("a", {
      class: normalizeClass({
        'vue3-paginate-not-allowed': i === $props.currentPage,
        [$props.paginationLinkClass]: $props.paginationLinkClass
      })
    }, toDisplayString(i), 3)], 14, _hoisted_7);
  }), 128)), createElementVNode("li", {
    style: normalizeStyle($options.sizeStyle),
    class: normalizeClass({
      'vue3-paginate-not-allowed': $props.totalPage <= $props.currentPage,
      'vue3-paginate-pagination-item': [undefined, null, ''].includes($props.paginationItemClass),
      [$props.paginationItemClass]: $props.paginationItemClass
    }),
    onClick: _cache[2] || (_cache[2] = $event => $props.totalPage <= $props.currentPage ? null : $options.handlePageChange($props.currentPage + 1))
  }, [createElementVNode("a", {
    title: $props.nextTitle,
    class: normalizeClass({
      'vue3-paginate-not-allowed': $props.totalPage <= $props.currentPage,
      [$props.paginationLinkClass]: $props.paginationLinkClass
    })
  }, [(openBlock(), createElementBlock("svg", {
    style: normalizeStyle($options.iconSizeStyle),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512"
  }, _hoisted_10, 4))], 10, _hoisted_8)], 6), createElementVNode("li", {
    style: normalizeStyle($options.sizeStyle),
    class: normalizeClass({
      'vue3-paginate-not-allowed': $props.totalPage <= $props.currentPage,
      'vue3-paginate-pagination-item': [undefined, null, ''].includes($props.paginationItemClass),
      [$props.paginationItemClass]: $props.paginationItemClass
    }),
    onClick: _cache[3] || (_cache[3] = $event => $props.totalPage <= $props.currentPage ? null : $options.handlePageChange($props.totalPage))
  }, [createElementVNode("a", {
    title: $props.lastTitle,
    class: normalizeClass({
      'vue3-paginate-not-allowed': $props.totalPage <= $props.currentPage,
      [$props.paginationLinkClass]: $props.paginationLinkClass
    })
  }, [(openBlock(), createElementBlock("svg", {
    style: normalizeStyle($options.iconSizeStyle),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512"
  }, _hoisted_13, 4))], 10, _hoisted_11)], 6)], 2)) : createCommentVNode("", true);
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = "\n@import url(\"https://fonts.googleapis.com/css2?family=Gideon+Roman&display=swap\");\n*[data-v-f6c6472e] {\n  margin: 0;\n  padding: 0;\n}\n.vue3-paginate-pagination-container[data-v-f6c6472e] {\n  font-family: \"Gideon Roman\", cursive;\n  display: flex;\n}\n.vue3-paginate-pagination-item[data-v-f6c6472e] {\n  cursor: pointer;\n  color: white;\n  background: whitesmoke;\n  border: 1px solid #dee2e6;\n  margin: 2px;\n  padding: 4px;\n  font-size: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.vue3-paginate-pagination-item a[data-v-f6c6472e] {\n  color: black;\n  text-decoration: none;\n  display: flex;\n  padding: auto;\n}\n.vue3-paginate-pagination-item a img[data-v-f6c6472e] {\n  user-drag: none;\n  -webkit-user-drag: none;\n  user-select: none;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n}\n.vue3-paginate-active[data-v-f6c6472e] {\n  border-radius: 100%;\n  background: #0f5298;\n}\n.vue3-paginate-active a[data-v-f6c6472e] {\n  color: #fff;\n  font-weight: bold;\n}\n.vue3-paginate-not-allowed[data-v-f6c6472e] {\n  cursor: not-allowed;\n}\n";
styleInject(css_248z);

script.render = render;
script.__scopeId = "data-v-f6c6472e";

// Import vue component
// IIFE injects install function into component, allowing component
// to be registered via Vue.use() as well as Vue.component(),

var entry_esm = /*#__PURE__*/(() => {
  // Get component instance
  const installable = script; // Attach install function executed by Vue.use()

  installable.install = app => {
    app.component('Vue3Paginate', installable);
  };

  return installable;
})(); // It's possible to expose named exports when writing components that can
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = directive;

export { entry_esm as default };
